import { gql } from '@apollo/client/core';

export const INTERNAL_FEATURE_FLAG_FIELDS = gql`
  fragment InternalFeatureFlagFields on FeatureFlag {
    feature
    displayName
  }
`;

export const INTERNAL_FEATURE_INVENTORY_FIELDS = gql`
  fragment InternalFeatureInventoryFields on FeatureInventory {
    feature
    displayName
    accountCount
    enabledByDefault
  }
`;

// Only `id` and `name` of the account: the screen renders a name and links by id, and `Account`
// carries fee structures and Soundcheck loans nothing here reads.
export const INTERNAL_FEATURE_ACCOUNT_FIELDS = gql`
  fragment InternalFeatureAccountFields on FeatureAccount {
    holdsFeature
    account {
      id
      name
    }
  }
`;

export const INTERNAL_FEATURE_FLAG_HISTORY_ENTRY_FIELDS = gql`
  fragment InternalFeatureFlagHistoryEntryFields on FeatureFlagHistoryEntry {
    id
    accountId
    accountName
    batchId
    changedAt
    defaultScope
    enabled
    feature
    actor {
      id
      email
      name
    }
  }
`;
